import styled from 'styled-components';

export const ScTopGamesCard = styled.div<{ staticScroll?: boolean }>`
  border-radius: 20px;
  background: linear-gradient(341deg, #ab1d63 -10.86%, #f06723 95.6%);
  display: flex;
  padding: 16px 16px 0 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  height: 450px;
  overflow-y: ${({ staticScroll }) => (staticScroll ? 'hidden' : 'auto')};

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  & > .title {
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 0.96px;
    text-transform: uppercase;
    flex-shrink: 0;
  }

  & > .games {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    padding-bottom: 16px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    flex: 1;
    min-height: 0;
    overflow-y: ${({ staticScroll }) => (staticScroll ? 'auto' : 'visible')};

    grid-auto-rows: max-content;
    align-items: start;

    & > .game {
      border-radius: 16px;
      overflow: hidden;
      height: auto;
    }
  }
`;
